import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  Chip,
  Alert,
  Snackbar,
  CircularProgress,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Paper,
  TextField,
  IconButton,
  Avatar,
  Badge,
  useTheme,
  alpha,
  LinearProgress,
  CardActionArea,
  CardActions,
  Stack,
  Skeleton,
  Fab,
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon,
  Backdrop,
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ToggleButton,
  ToggleButtonGroup,
  AlertTitle,
  Breadcrumbs,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
  Autocomplete,
  InputAdornment,
  OutlinedInput,
  InputBase,
  Popper,
  Menu,
  ListItemButton,
  ListItemAvatar,
  Collapse,
  useMediaQuery,
  useScrollTrigger,
  AppBar,
  Toolbar,
  Drawer,
  ListSubheader,
  Divider as MuiDivider,
  Box as MuiBox
} from '@mui/material';
import socketService from '../services/socketService';
import {
  Chat as ChatIcon,
  Send as SendIcon,
  Refresh as RefreshIcon,
  Settings as SettingsIcon,
  Person as PersonIcon,
  Support as SupportIcon,
  AdminPanelSettings as AdminIcon,
  SupervisedUserCircle as SuperAdminIcon,
  Assignment as AgentIcon,
  Notifications as NotificationsIcon,
  Warning as WarningIcon,
  CheckCircle as CheckCircleIcon,
  ExpandMore as ExpandMoreIcon,
  Psychology as PsychologyIcon,
  AutoAwesome as AutoAwesomeIcon,
  RocketLaunch as RocketLaunchIcon,
  Science as ScienceIcon,
  Insights as InsightsIcon,
  Timeline as TimelineIcon,
  TrendingDown as TrendingDownIcon,
  AccountBalance as AccountBalanceIcon,
  VerifiedUser as VerifiedUserIcon,
  People as GroupIcon,
  Timeline as ActivityIcon,
  ScheduleSend as ScheduleSendIcon,
  CampaignOutlined as CampaignOutlinedIcon,
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as VisibilityIcon,
  Download as DownloadIcon,
  Upload as UploadIcon,
  FilterList as FilterListIcon,
  Search as SearchIcon,
  MoreVert as MoreVertIcon,
  Star as StarIcon,
  StarBorder as StarBorderIcon,
  Favorite as FavoriteIcon,
  FavoriteBorder as FavoriteBorderIcon,
  ThumbUp as ThumbUpIcon,
  ThumbDown as ThumbDownIcon,
  Share as ShareIcon,
  Print as PrintIcon,
  ContentCopy as ContentCopyIcon,
  VisibilityOff as VisibilityOffIcon,
  Lock as LockIcon,
  Security as SecurityIcon,
  Speed as SpeedIcon,
  TrendingFlat as TrendingFlatIcon,
  ShowChart as ShowChartIcon,
  PieChart as PieChartIcon,
  BarChart as BarChartIcon,
  ScatterPlot as ScatterPlotIcon,
  BubbleChart as BubbleChartIcon,
  DonutLarge as DonutLargeIcon,
  DonutSmall as DonutSmallIcon,
  MultilineChart as MultilineChartIcon,
  Timeline as TimelineIcon2,
  Assessment as AssessmentIcon,
  Analytics as AnalyticsIcon2,
  DataUsage as DataUsageIcon,
  Storage as StorageIcon,
  Cloud as CloudIcon,
  CloudUpload as CloudUploadIcon,
  CloudDownload as CloudDownloadIcon,
  Sync as SyncIcon,
  SyncDisabled as SyncDisabledIcon,
  Pause as PauseIcon,
  PlayArrow as PlayArrowIcon,
  Stop as StopIcon,
  SkipNext as SkipNextIcon,
  SkipPrevious as SkipPreviousIcon,
  FastForward as FastForwardIcon,
  FastRewind as FastRewindIcon,
  VolumeUp as VolumeUpIcon,
  VolumeDown as VolumeDownIcon,
  VolumeOff as VolumeOffIcon,
  Brightness4 as Brightness4Icon,
  Brightness7 as Brightness7Icon,
  Palette as PaletteIcon,
  Brush as BrushIcon,
  FormatPaint as FormatPaintIcon,
  ColorLens as ColorLensIcon,
  Gradient as GradientIcon,
  Opacity as OpacityIcon,
  BlurOn as BlurOnIcon,
  BlurOff as BlurOffIcon,
  CenterFocusStrong as CenterFocusStrongIcon,
  CenterFocusWeak as CenterFocusWeakIcon,
  Crop as CropIcon,
  CropFree as CropFreeIcon,
  CropSquare as CropSquareIcon,
  Crop169 as Crop169Icon,
  Crop32 as Crop32Icon,
  Crop54 as Crop54Icon,
  Crop75 as Crop75Icon,
  CropDin as CropDinIcon,
  CropLandscape as CropLandscapeIcon,
  CropPortrait as CropPortraitIcon,
  CropRotate as CropRotateIcon,
  CropSquare as CropSquareIcon2,
  Filter1 as Filter1Icon,
  Filter2 as Filter2Icon,
  Filter3 as Filter3Icon,
  Filter4 as Filter4Icon,
  Filter5 as Filter5Icon,
  Filter6 as Filter6Icon,
  Filter7 as Filter7Icon,
  Filter8 as Filter8Icon,
  Filter9 as Filter9Icon,
  Filter9Plus as Filter9PlusIcon,
  FilterAlt as FilterAltIcon,
  FilterAltOff as FilterAltOffIcon,
  FilterBAndW as FilterBAndWIcon,
  FilterCenterFocus as FilterCenterFocusIcon,
  FilterDrama as FilterDramaIcon,
  FilterFrames as FilterFramesIcon,
  FilterHdr as FilterHdrIcon,
  FilterNone as FilterNoneIcon,
  FilterTiltShift as FilterTiltShiftIcon,
  FilterVintage as FilterVintageIcon,
  Flare as FlareIcon,
  FlashAuto as FlashAutoIcon,
  FlashOff as FlashOffIcon,
  FlashOn as FlashOnIcon,
  Flip as FlipIcon,
  FlipCameraAndroid as FlipCameraAndroidIcon,
  FlipCameraIos as FlipCameraIosIcon,
  Grain as GrainIcon,
  GridOff as GridOffIcon,
  GridOn as GridOnIcon,
  HdrOff as HdrOffIcon,
  HdrOn as HdrOnIcon,
  HdrStrong as HdrStrongIcon,
  HdrWeak as HdrWeakIcon,
  Healing as HealingIcon,
  Image as ImageIcon,
  ImageAspectRatio as ImageAspectRatioIcon,
  ImageNotSupported as ImageNotSupportedIcon,
  ImageSearch as ImageSearchIcon,
  Iso as IsoIcon,
  Landscape as LandscapeIcon,
  LeakAdd as LeakAddIcon,
  LeakRemove as LeakRemoveIcon,
  Lens as LensIcon,
  LinkedCamera as LinkedCameraIcon,
  Looks as LooksIcon,
  Looks3 as Looks3Icon,
  Looks4 as Looks4Icon,
  Looks5 as Looks5Icon,
  Looks6 as Looks6Icon,
  LooksOne as LooksOneIcon,
  LooksTwo as LooksTwoIcon,
  Loupe as LoupeIcon,
  MonochromePhotos as MonochromePhotosIcon,
  MovieCreation as MovieCreationIcon,
  MovieFilter as MovieFilterIcon,
  MusicNote as MusicNoteIcon,
  Nature as NatureIcon,
  NaturePeople as NaturePeopleIcon,
  NavigateBefore as NavigateBeforeIcon,
  NavigateNext as NavigateNextIcon,
  Palette as PaletteIcon2,
  Panorama as PanoramaIcon,
  PanoramaFishEye as PanoramaFishEyeIcon,
  PanoramaHorizontal as PanoramaHorizontalIcon,
  PanoramaVertical as PanoramaVerticalIcon,
  PanoramaWideAngle as PanoramaWideAngleIcon,
  Photo as PhotoIcon,
  PhotoAlbum as PhotoAlbumIcon,
  PhotoCamera as PhotoCameraIcon,
  PhotoFilter as PhotoFilterIcon,
  PhotoLibrary as PhotoLibraryIcon,
  PhotoSizeSelectActual as PhotoSizeSelectActualIcon,
  PhotoSizeSelectLarge as PhotoSizeSelectLargeIcon,
  PhotoSizeSelectSmall as PhotoSizeSelectSmallIcon,
  PictureAsPdf as PictureAsPdfIcon,
  Portrait as PortraitIcon,
  RemoveRedEye as RemoveRedEyeIcon,
  Rotate90DegreesCcw as Rotate90DegreesCcwIcon,
  RotateLeft as RotateLeftIcon,
  RotateRight as RotateRightIcon,
  ShutterSpeed as ShutterSpeedIcon,
  Slideshow as SlideshowIcon,
  Straighten as StraightenIcon,
  Style as StyleIcon,
  SwitchCamera as SwitchCameraIcon,
  SwitchVideo as SwitchVideoIcon,
  TagFaces as TagFacesIcon,
  Texture as TextureIcon,
  Timelapse as TimelapseIcon,
  Timer as TimerIcon,
  Timer3 as Timer3Icon,
  Timer10 as Timer10Icon,
  TimerOff as TimerOffIcon,
  Tonality as TonalityIcon,
  Transform as TransformIcon,
  Tune as TuneIcon,
  ViewComfy as ViewComfyIcon,
  ViewCompact as ViewCompactIcon,
  Vignette as VignetteIcon,
  WbAuto as WbAutoIcon,
  WbCloudy as WbCloudyIcon,
  WbIncandescent as WbIncandescentIcon,
  WbIridescent as WbIridescentIcon,
  WbSunny as WbSunnyIcon,
  ThreeSixty as ThreeSixtyIcon,
  ZoomIn as ZoomInIcon,
  ZoomOut as ZoomOutIcon,
  Close as CloseIcon
} from '@mui/icons-material';
import api from '../services/api';
import { logActivity, ActivityTypes } from '../utils/activityLogger';

const ChatPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [chats, setChats] = useState([]);
  const [selectedChat, setSelectedChat] = useState(null);
  const [messages, setMessages] = useState([]);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [messageText, setMessageText] = useState('');
  const [sending, setSending] = useState(false);
  const [filterType, setFilterType] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [currentUser, setCurrentUser] = useState(null);
  const [showStats, setShowStats] = useState(false);
  const [mediaPreview, setMediaPreview] = useState({ open: false, url: '', type: '' });
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadingMedia, setUploadingMedia] = useState(false);
  const [chatStats, setChatStats] = useState({
    totalChats: 0,
    activeChats: 0,
    resolvedChats: 0,
    averageResponseTime: 0
  });

  const messagesEndRef = useRef(null);
  const [drawerOpen, setDrawerOpen] = useState(!isMobile);
  const [isTyping, setIsTyping] = useState(false);
  const [typingTimer, setTypingTimer] = useState(null);

  // Message persistence
  const [pendingMessages, setPendingMessages] = useState([]);
  const [isOnline, setIsOnline] = useState(false);
  const [syncTimer, setSyncTimer] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Debug typing state changes
  useEffect(() => {
    console.log('React: isTyping state changed to:', isTyping);
  }, [isTyping]);

  useEffect(() => {
    loadCurrentUser();
    loadChats();
    loadChatStats();

    // Initialize Socket.IO
    initializeSocketIO();

    // Cleanup on unmount
    return () => {
      socketService.dispose();
      if (typingTimer) {
        clearTimeout(typingTimer);
      }
      if (syncTimer) {
        clearInterval(syncTimer);
      }
    };
  }, []);

  useEffect(() => {
    if (selectedChat) {
      // Leave previous chat room
      socketService.leaveChat();

      // Join new chat room
      if (socketService.isConnected) {
        console.log('React: Joining chat room:', selectedChat._id);
        socketService.joinChat(selectedChat._id);

        // Re-authenticate when joining a chat to ensure proper connection
        setTimeout(() => {
          console.log('React: Re-authenticating after joining chat');
          authenticateUser();
        }, 500);
      } else {
        console.log('React: Socket not connected, cannot join chat room');
      }

      // Load messages once when selecting chat
      loadMessages(selectedChat._id);
    }
  }, [selectedChat]);

  useEffect(() => {
    if (selectedChat) {
      loadMessages(selectedChat._id);
    }
  }, [selectedChat]);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const initializeSocketIO = () => {
    // Initialize socket connection
    socketService.initialize('https://api.utiliti.ng');

    // Setup event listeners
    socketService.onConnected = () => {
      console.log('React: Socket.IO connected successfully');
      setIsOnline(true);
      authenticateUser();
      syncPendingMessages(); // Sync any pending messages

      // Check online users after connection
      setTimeout(() => {
        socketService.socket.emit('getOnlineUsers');
      }, 1000);
    };

    socketService.onDisconnected = () => {
      console.log('React: Socket.IO disconnected');
      setIsOnline(false);
    };

    socketService.onError = (error) => {
      console.log('React: Socket.IO error:', error);
      setIsOnline(false);
      setSnackbar({
        open: true,
        message: `Connection error: ${error}`,
        severity: 'error'
      });
    };

    socketService.onMessageReceived = (data) => {
      console.log('React: Received new message via socket');
      handleNewMessage(data);
    };

    socketService.onTypingStatus = (data) => {
      console.log('React: Received typing status via socket');
      handleTypingStatus(data);
    };

    socketService.onMessagesRead = (data) => {
      console.log('React: Received messages read via socket');
      handleMessagesRead(data);
    };

    // Add online users listener
    socketService.socket.on('onlineUsers', (users) => {
      console.log('React: Online users:', users);
    });

    socketService.socket.on('userOnlineStatus', (data) => {
      console.log('React: User online status:', data);
    });

    // Add test connection response handler
    socketService.socket.on('testConnectionResponse', (data) => {
      console.log('React: Test connection response:', data);
    });

    socketService.socket.on('authenticated', (data) => {
      console.log('React: Authentication response:', data);
      setIsAuthenticated(data.success);
      if (data.success) {
        console.log('React: Successfully authenticated with socket server');
      } else {
        console.log('React: Authentication failed:', data.error);
      }
    });

    // Connect to server
    console.log('React: Attempting to connect to socket server...');
    socketService.connect();

    // Start sync timer for offline messages
    startSyncTimer();
  };

  const startSyncTimer = () => {
    const timer = setInterval(() => {
      if (isOnline && pendingMessages.length > 0) {
        syncPendingMessages();
      }
    }, 30000); // Check every 30 seconds

    setSyncTimer(timer);
  };

  const syncPendingMessages = async () => {
    if (pendingMessages.length === 0 || !isOnline || !selectedChat) return;

    console.log('React: Syncing', pendingMessages.length, 'pending messages');

    const messagesToSync = [...pendingMessages];
    setPendingMessages([]);

    for (const message of messagesToSync) {
      try {
        console.log('React: Syncing message:', message.content);

        if (socketService.isConnected) {
          socketService.sendMessage(
            selectedChat._id,
            message.content,
            message.receiver,
            message.replyTo
          );
        } else {
          // Fallback to HTTP API
          const response = await api.chat.sendMessage({
            chatId: selectedChat._id,
            content: message.content,
            receiver: message.receiver
          });

          if (!response.success) {
            // Add back to pending if failed
            setPendingMessages(prev => [...prev, message]);
            console.log('React: Failed to sync message, added back to pending');
          }
        }
      } catch (error) {
        console.error('React: Error syncing message:', error);
        setPendingMessages(prev => [...prev, message]);
      }
    }
  };

  const authenticateUser = () => {
    if (currentUser) {
      console.log('React: Current user structure:', currentUser);
      const userId = currentUser.id || currentUser._id || currentUser.userId;
      console.log('React: Authenticating user with socket:', currentUser.username, userId);

      // Add more detailed logging
      console.log('React: Socket service available:', !!socketService);
      console.log('React: Socket connected:', socketService.isConnected);
      console.log('React: Socket object:', socketService.socket);

      if (socketService.isConnected && socketService.socket) {
        // Clear any existing authentication first
        socketService.socket.emit('logout', { username: currentUser.username });

        // Wait a bit then authenticate
        setTimeout(() => {
          socketService.authenticate(userId, currentUser.username);

          // Also emit a test event to verify connection
          socketService.socket.emit('testConnection', {
            username: currentUser.username,
            timestamp: new Date().toISOString()
          });

          console.log('React: Authentication request sent');
        }, 100);
      } else {
        console.log('React: Socket not connected, cannot authenticate');
      }
    } else {
      console.log('React: No current user available for socket authentication');
    }
  };

  const handleNewMessage = (data) => {
    try {
      console.log('React: Received new message via socket');
      console.log('React: Message data:', data);

      const messageData = data.message;
      console.log('React: Message content:', messageData?.content);
      console.log('React: Message sender:', messageData?.sender);
      console.log('React: Current user:', currentUser?.username);
      console.log('React: Selected chat:', selectedChat?._id);

      // Add message to local state
      setMessages(prev => {
        console.log('React: Previous messages count:', prev.length);
        const newMessages = [...prev, messageData];
        console.log('React: New messages count:', newMessages.length);
        return newMessages;
      });

      // Auto-scroll to bottom for new messages
      scrollToBottom();

      // Mark messages as read if they're not from current user
      if (messageData.sender !== currentUser?.username) {
        console.log('React: Marking message as read');
        markMessagesAsRead([messageData._id]);
      }

      console.log('New message added via Socket.IO:', messageData.content);
    } catch (error) {
      console.error('Error handling new message:', error);
    }
  };

  const handleTypingStatus = (data) => {
    try {
      const sender = data.sender;
      const isTyping = data.isTyping;

      console.log('React: Received typing status:', { sender, isTyping, currentUser: currentUser?.username });

      // Only show typing indicator for messages not from current user
      if (sender !== currentUser?.username) {
        console.log('React: Setting typing indicator to:', isTyping);
        setIsTyping(isTyping);
      } else {
        console.log('React: Ignoring typing status from current user');
      }
    } catch (error) {
      console.error('Error handling typing status:', error);
    }
  };

  const handleMessagesRead = (data) => {
    try {
      const messageIds = data.messageIds;
      const readBy = data.readBy;

      setMessages(prev => prev.map(message => {
        if (messageIds.includes(message._id)) {
          return {
            ...message,
            readBy: [...(message.readBy || []), readBy],
            isRead: true
          };
        }
        return message;
      }));

      console.log('Messages marked as read via Socket.IO');
    } catch (error) {
      console.error('Error handling messages read:', error);
    }
  };

  const loadCurrentUser = async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      console.log('Current user loaded:', user);
      setCurrentUser(user);

      // Authenticate with socket if already connected
      if (socketService.isConnected) {
        socketService.authenticate(user.id, user.username);
      }
    } catch (error) {
      console.error('Error loading current user:', error);
      // Try to get user from API if not in localStorage
      try {
        const response = await api.auth.getProfile();
        if (response) {
          setCurrentUser(response);

          // Authenticate with socket if already connected
          if (socketService.isConnected) {
            socketService.authenticate(response.id, response.username);
          }
        }
      } catch (profileError) {
        console.error('Error loading user profile:', profileError);
      }
    }
  };

  const loadChats = async () => {
    try {
      // Silent refresh - don't show loading state
      const response = await api.chat.getAllChats();
      console.log('Silent refresh - chats response:', response);

      if (response && response.success) {
        console.log('Silent refresh - setting chats:', response.data);
        setChats(response.data || []);
      } else {
        console.error('Silent refresh - failed to load chats:', response?.error);
        // Don't show error to user for background refresh
      }
    } catch (error) {
      console.error('Silent refresh - error loading chats:', error);
      // Don't show error to user for background refresh
    }
  };

  const loadMessages = async (chatId) => {
    try {
      // Silent refresh - don't show loading state
      console.log('Loading messages for chat:', chatId);
      const response = await api.chat.getChatMessages(chatId);
      console.log('Messages response:', response);

      if (response && response.success) {
        console.log('Setting messages:', response.data);
        setMessages(response.data || []);

        // Mark unread messages as read when they are viewed
        const userId = currentUser?.id || currentUser?._id || currentUser?.userId;
        const unreadMessages = response.data.filter(message =>
          message.sender !== currentUser?.username && !message.readBy?.includes(userId)
        );

        if (unreadMessages.length > 0) {
          const messageIds = unreadMessages.map(msg => msg._id);
          markMessagesAsRead(messageIds);
        }
      } else {
        console.error('Failed to load messages:', response?.error);
      }
    } catch (error) {
      console.error('Error loading messages:', error);
    }
  };

  // Mark messages as read
  const markMessagesAsRead = async (messageIds) => {
    if (!selectedChat || !currentUser || !messageIds || messageIds.length === 0) return;
    try {
      console.log('Marking messages as read:', messageIds);
      const userId = currentUser.id || currentUser._id || currentUser.userId;

      // Use Socket.IO if connected, otherwise fallback to HTTP API
      if (socketService.isConnected) {
        socketService.markAsRead(selectedChat._id, messageIds);
      } else {
        const response = await api.chat.markMessagesAsRead(selectedChat._id, messageIds);

        if (response && response.success) {
          // Update local message read status
          setMessages(prev => prev.map(message => {
            if (messageIds.includes(message._id)) {
              return {
                ...message,
                readBy: [...(message.readBy || []), userId],
                isRead: true
              };
            }
            return message;
          }));
        }
      }
    } catch (error) {
      console.error('Error marking messages as read:', error);
    }
  };



  const loadChatStats = async () => {
    try {
      const response = await api.chat.getChatStats();
      if (response && response.success) {
        setChatStats(response.data);
      }
    } catch (error) {
      console.error('Error loading chat stats:', error);
    }
  };

  const sendMessage = async () => {
    if (!messageText.trim() || !selectedChat || sending) return;

    const message = messageText.trim();
    setMessageText('');
    setSending(true);

    try {
      // Determine the receiver - if current user is the receiver in the chat, 
      // then the sender should be the receiver for the message
      const receiver = selectedChat.receiver === currentUser?.username ?
        selectedChat.sender : selectedChat.receiver;

      console.log('React: Starting to send message:', message);
      console.log('React: Socket connected:', socketService.isConnected);
      console.log('React: Online status:', isOnline);
      console.log('React: Receiver:', receiver);

      // Stop typing indicator
      socketService.stopTyping(selectedChat._id);

      // Send message via Socket.IO if online
      if (socketService.isConnected && isOnline) {
        console.log('React: Sending via Socket.IO');
        socketService.sendMessage(selectedChat._id, message, receiver);

        // Add message to local state immediately for better UX
        const newMessage = {
          _id: Date.now().toString(), // Temporary ID
          sender: currentUser?.username,
          receiver: receiver,
          content: message,
          timestamp: new Date(),
          createdAt: new Date(),
          isRead: false,
          readBy: []
        };
        setMessages(prev => [...prev, newMessage]);

        // Log activity
        await logActivity({
          action: ActivityTypes.CHAT_MESSAGE,
          details: `Sent message to ${receiver}`,
          metadata: {
            chatId: selectedChat._id,
            messageLength: message.length
          }
        });
      } else {
        console.log('React: Offline or socket not connected, saving to pending');

        // Save message to pending queue
        const pendingMessage = {
          _id: Date.now().toString(),
          sender: currentUser?.username,
          receiver: receiver,
          content: message,
          timestamp: new Date(),
          createdAt: new Date(),
          isRead: false,
          readBy: []
        };

        setPendingMessages(prev => [...prev, pendingMessage]);
        console.log('React: Message added to pending queue. Total pending:', pendingMessages.length + 1);

        // Add message to local state for immediate display
        setMessages(prev => [...prev, pendingMessage]);

        // Try HTTP API as fallback
        const response = await api.chat.sendMessage({
          chatId: selectedChat._id,
          content: message,
          receiver: receiver
        });

        console.log('React: HTTP API response:', response);

        if (response && response.success) {
          // Remove from pending if HTTP succeeded
          setPendingMessages(prev => prev.filter(m => m._id !== pendingMessage._id));
          console.log('React: Message sent successfully via HTTP API, removed from pending');
        } else {
          console.log('React: HTTP API failed, message remains in pending queue');
        }
      }
    } catch (error) {
      console.error('React: Error sending message:', error);

      // Add to pending if not already there
      const pendingMessage = {
        _id: Date.now().toString(),
        sender: currentUser?.username,
        receiver: selectedChat.receiver === currentUser?.username ?
          selectedChat.sender : selectedChat.receiver,
        content: message,
        timestamp: new Date(),
        createdAt: new Date(),
        isRead: false,
        readBy: []
      };

      setPendingMessages(prev => {
        if (!prev.find(m => m._id === pendingMessage._id)) {
          return [...prev, pendingMessage];
        }
        return prev;
      });

      setSnackbar({
        open: true,
        message: 'Failed to send message. It will be sent when connection is restored.',
        severity: 'warning'
      });
    } finally {
      setSending(false);
    }
  };

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      sendMediaMessage(file);
    }
  };

  const sendMediaMessage = async (file) => {
    if (!selectedChat || uploadingMedia) return;

    setUploadingMedia(true);
    try {
      // Determine the receiver
      const receiver = selectedChat.receiver === currentUser?.username ?
        selectedChat.sender : selectedChat.receiver;

      // First upload the file via HTTP API
      const response = await api.chat.sendMediaMessage({
        chatId: selectedChat._id,
        receiver: receiver,
        file: file,
        messageType: file.type.startsWith('image/') ? 'image' : 'file'
      });

      if (response && response.success) {
        // Send media message via Socket.IO if connected
        if (socketService.isConnected) {
          socketService.sendMediaMessage(
            selectedChat._id,
            receiver,
            response.data.mediaUrl,
            response.data.mediaFileName || file.name,
            file.size,
            file.type,
            file.type.startsWith('image/') ? 'image' : 'file'
          );
        }

        // Add message to local state
        const newMessage = {
          ...response.data,
          sender: currentUser?.username,
          receiver: receiver
        };
        setMessages(prev => [...prev, newMessage]);

        // Log activity
        await logActivity({
          action: ActivityTypes.CHAT_MESSAGE,
          details: `Sent media message to ${receiver}`,
          metadata: {
            chatId: selectedChat._id,
            mediaType: file.type
          }
        });
      }
    } catch (error) {
      console.error('Error sending media message:', error);
      setSnackbar({
        open: true,
        message: 'Failed to send media message',
        severity: 'error'
      });
    } finally {
      setUploadingMedia(false);
      setSelectedFile(null);
    }
  };

  const handleMediaPreview = (url, type) => {
    setMediaPreview({ open: true, url, type });
  };

  const closeMediaPreview = () => {
    setMediaPreview({ open: false, url: '', type: '' });
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleSnackbarClose = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  const getChatIcon = (type) => {
    const icons = {
      'admin': <AdminIcon />,
      'support': <SupportIcon />,
      'agent': <AgentIcon />,
      'superadmin': <SuperAdminIcon />
    };
    return icons[type] || <PersonIcon />;
  };

  const getChatColor = (type) => {
    const colors = {
      'admin': 'primary',
      'support': 'success',
      'agent': 'warning',
      'superadmin': 'error'
    };
    return colors[type] || 'default';
  };

  const handleChatSelect = (chat) => {
    console.log('Selecting chat:', chat);
    setSelectedChat(chat);
    setMessages([]); // Clear messages when selecting new chat
  };

  const filteredChats = chats.filter(chat => {
    const matchesSearch = chat.sender?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      chat.chatName?.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesFilter = filterType === 'all' || chat.status === filterType;
    return matchesSearch && matchesFilter;
  });

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleDateString();
  };

  return (
    <Box sx={{
      p: 3,
      minHeight: '100vh',
      background: theme.palette.background.default
    }}>
      {/* Header Section */}
      <Box sx={{ mb: 3 }}>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          p: 3,
          borderRadius: 3,
          background: `linear-gradient(135deg, ${theme.palette.primary.main}15, ${theme.palette.secondary.main}15)`,
          border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
          boxShadow: theme.shadows[2],
          backdropFilter: 'blur(10px)'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Avatar sx={{
              background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
              width: 56,
              height: 56,
              boxShadow: theme.shadows[3]
            }}>
              <ChatIcon sx={{ fontSize: 28, color: 'white' }} />
            </Avatar>
            <Box>
              <Typography variant="h4" sx={{
                fontWeight: 700,
                mb: 0.5,
                background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
                Customer Support Chat
              </Typography>
              <Typography variant="body1" sx={{
                color: theme.palette.text.secondary,
                lineHeight: 1.4,
                fontWeight: 500
              }}>
                Manage customer conversations and provide real-time support
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Chip
              icon={socketService.isConnected ? <SyncIcon /> : <SyncDisabledIcon />}
              label={socketService.isConnected ? "Live" : "Offline"}
              size="small"
              color={socketService.isConnected ? "success" : "error"}
              variant="filled"
              sx={{
                fontWeight: 600,
                boxShadow: theme.shadows[1]
              }}
            />
            {(pendingMessages.length > 0 || !isOnline) && (
              <Chip
                icon={!isOnline ? <SyncDisabledIcon /> : <ScheduleSendIcon />}
                label={!isOnline ? "Offline" : `${pendingMessages.length} pending`}
                size="small"
                color={!isOnline ? "warning" : "info"}
                variant="filled"
                sx={{
                  fontWeight: 600,
                  boxShadow: theme.shadows[1]
                }}
              />
            )}
            <Chip
              icon={isAuthenticated ? <CheckCircleIcon /> : <WarningIcon />}
              label={isAuthenticated ? "Authenticated" : "Not Authenticated"}
              size="small"
              color={isAuthenticated ? "success" : "error"}
              variant="filled"
              sx={{
                fontWeight: 600,
                boxShadow: theme.shadows[1]
              }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={loadChats}
              startIcon={<RefreshIcon />}
              sx={{
                fontWeight: 600,
                boxShadow: theme.shadows[2],
                '&:hover': {
                  boxShadow: theme.shadows[4],
                }
              }}
            >
              Refresh Chats
            </Button>

            {/* Debug Authentication Button */}
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => {
                console.log('React: Manual authentication trigger');
                authenticateUser();
              }}
              sx={{
                fontWeight: 600,
                ml: 1
              }}
            >
              Debug Auth
            </Button>

            {/* Force Authentication Button */}
            <Button
              variant="contained"
              color={isAuthenticated ? "success" : "error"}
              onClick={() => {
                console.log('React: Force authentication');
                if (socketService.isConnected) {
                  socketService.socket.emit('logout', { username: currentUser?.username });
                  setTimeout(() => {
                    authenticateUser();
                  }, 200);
                }
              }}
              sx={{
                fontWeight: 600,
                ml: 1
              }}
            >
              {isAuthenticated ? "Re-Auth" : "Force Auth"}
            </Button>
          </Box>
        </Box>
      </Box>

      {/* Stats Cards */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={6} md={3}>
          <Card sx={{
            borderRadius: 3,
            background: `linear-gradient(135deg, ${theme.palette.primary.main}10, ${theme.palette.primary.main}20)`,
            border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
            boxShadow: theme.shadows[2],
            transition: 'all 0.3s ease',
            '&:hover': {
              transform: 'translateY(-4px)',
              boxShadow: theme.shadows[4]
            }
          }}>
            <CardContent sx={{ textAlign: 'center', p: 3 }}>
              <Typography variant="h3" sx={{
                fontWeight: 800,
                background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
                {chatStats.totalChats}
              </Typography>
              <Typography variant="body2" sx={{
                color: theme.palette.text.secondary,
                fontWeight: 600,
                mt: 1
              }}>
                Total Chats
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={6} md={3}>
          <Card sx={{
            borderRadius: 3,
            background: `linear-gradient(135deg, ${theme.palette.success.main}10, ${theme.palette.success.main}20)`,
            border: `1px solid ${alpha(theme.palette.success.main, 0.1)}`,
            boxShadow: theme.shadows[2],
            transition: 'all 0.3s ease',
            '&:hover': {
              transform: 'translateY(-4px)',
              boxShadow: theme.shadows[4]
            }
          }}>
            <CardContent sx={{ textAlign: 'center', p: 3 }}>
              <Typography variant="h3" sx={{
                fontWeight: 800,
                background: `linear-gradient(135deg, ${theme.palette.success.main}, ${theme.palette.success.light})`,
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
                {chatStats.activeChats}
              </Typography>
              <Typography variant="body2" sx={{
                color: theme.palette.text.secondary,
                fontWeight: 600,
                mt: 1
              }}>
                Active Chats
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={6} md={3}>
          <Card sx={{
            borderRadius: 3,
            background: `linear-gradient(135deg, ${theme.palette.warning.main}10, ${theme.palette.warning.main}20)`,
            border: `1px solid ${alpha(theme.palette.warning.main, 0.1)}`,
            boxShadow: theme.shadows[2],
            transition: 'all 0.3s ease',
            '&:hover': {
              transform: 'translateY(-4px)',
              boxShadow: theme.shadows[4]
            }
          }}>
            <CardContent sx={{ textAlign: 'center', p: 3 }}>
              <Typography variant="h3" sx={{
                fontWeight: 800,
                background: `linear-gradient(135deg, ${theme.palette.warning.main}, ${theme.palette.warning.light})`,
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
                {chatStats.resolvedChats}
              </Typography>
              <Typography variant="body2" sx={{
                color: theme.palette.text.secondary,
                fontWeight: 600,
                mt: 1
              }}>
                Resolved
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={6} md={3}>
          <Card sx={{
            borderRadius: 3,
            background: `linear-gradient(135deg, ${theme.palette.info.main}10, ${theme.palette.info.main}20)`,
            border: `1px solid ${alpha(theme.palette.info.main, 0.1)}`,
            boxShadow: theme.shadows[2],
            transition: 'all 0.3s ease',
            '&:hover': {
              transform: 'translateY(-4px)',
              boxShadow: theme.shadows[4]
            }
          }}>
            <CardContent sx={{ textAlign: 'center', p: 3 }}>
              <Typography variant="h3" sx={{
                fontWeight: 800,
                background: `linear-gradient(135deg, ${theme.palette.info.main}, ${theme.palette.info.light})`,
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
                {chatStats.averageResponseTime}m
              </Typography>
              <Typography variant="body2" sx={{
                color: theme.palette.text.secondary,
                fontWeight: 600,
                mt: 1
              }}>
                Avg Response
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Main Chat Interface */}
      <Grid container spacing={2} sx={{ height: 'calc(100vh - 450px)' }}>
        {/* Chat List Sidebar */}
        <Grid item xs={12} md={3}>
          <Card sx={{
            height: '100%',
            borderRadius: 3,
            display: 'flex',
            flexDirection: 'column',
            background: `linear-gradient(135deg, ${theme.palette.background.paper}, ${alpha(theme.palette.primary.main, 0.02)})`,
            border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
            boxShadow: theme.shadows[3]
          }}>
            <CardContent sx={{ p: 1.5, pb: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, fontSize: '0.9rem' }}>
                  Conversations
                </Typography>
                <Badge badgeContent={chats.length} color="primary" size="small" />
              </Box>

              {/* Search and Filter */}
              <TextField
                fullWidth
                size="small"
                placeholder="Search..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                InputProps={{
                  startAdornment: <SearchIcon sx={{ mr: 0.5, color: 'text.secondary', fontSize: '1rem' }} />
                }}
                sx={{ mb: 1.5, '& .MuiInputBase-root': { fontSize: '0.8rem' } }}
              />

              <FormControl fullWidth size="small" sx={{ mb: 1.5 }}>
                <InputLabel sx={{ fontSize: '0.8rem' }}>Filter</InputLabel>
                <Select
                  value={filterType}
                  onChange={(e) => setFilterType(e.target.value)}
                  label="Filter"
                  sx={{ fontSize: '0.8rem' }}
                >
                  <MenuItem value="all" sx={{ fontSize: '0.8rem' }}>All Chats</MenuItem>
                  <MenuItem value="active" sx={{ fontSize: '0.8rem' }}>Active</MenuItem>
                  <MenuItem value="resolved" sx={{ fontSize: '0.8rem' }}>Resolved</MenuItem>
                  <MenuItem value="pending" sx={{ fontSize: '0.8rem' }}>Pending</MenuItem>
                </Select>
              </FormControl>
            </CardContent>

            <Divider />

            {/* Chat List */}
            <Box sx={{
              flex: 1,
              overflow: 'auto',
              overflowX: 'hidden',
              '&::-webkit-scrollbar': {
                width: '4px',
              },
              '&::-webkit-scrollbar-track': {
                background: alpha(theme.palette.divider, 0.1),
                borderRadius: '2px',
              },
              '&::-webkit-scrollbar-thumb': {
                background: alpha(theme.palette.primary.main, 0.3),
                borderRadius: '2px',
                '&:hover': {
                  background: alpha(theme.palette.primary.main, 0.5),
                },
              },
            }}>
              {filteredChats.length > 0 ? (
                filteredChats.filter(chat => chat && chat._id).map((chat) => (
                  <CardActionArea
                    key={chat._id}
                    onClick={() => handleChatSelect(chat)}
                    sx={{
                      p: 1,
                      borderBottom: `1px solid ${theme.palette.divider}`,
                      bgcolor: selectedChat?._id === chat._id ?
                        alpha(theme.palette.primary.main, 0.1) : 'transparent',
                      '&:hover': {
                        bgcolor: alpha(theme.palette.primary.main, 0.05)
                      }
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5, width: '100%' }}>
                      <Avatar sx={{
                        bgcolor: getChatColor(chat.receiverType) === 'primary' ?
                          theme.palette.primary.main : theme.palette.secondary.main,
                        width: 28,
                        height: 28,
                        fontSize: '0.7rem',
                        flexShrink: 0
                      }}>
                        {getChatIcon(chat.receiverType)}
                      </Avatar>
                      <Box sx={{ flex: 1, minWidth: 0, overflow: 'hidden' }}>
                        <Typography variant="body2" sx={{
                          fontWeight: 600,
                          color: theme.palette.text.primary,
                          fontSize: '0.75rem',
                          lineHeight: 1.2,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap'
                        }}>
                          {chat.sender || 'Unknown User'}
                        </Typography>
                        <Typography variant="caption" sx={{
                          color: theme.palette.text.secondary,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          fontSize: '0.65rem',
                          lineHeight: 1.2,
                          display: 'block'
                        }}>
                          {chat.latestMessage || 'No messages yet'}
                        </Typography>
                        <Typography variant="caption" sx={{
                          color: theme.palette.text.secondary,
                          fontSize: '0.6rem',
                          display: 'block'
                        }}>
                          {formatTime(chat.updatedAt)}
                        </Typography>
                      </Box>
                      <Chip
                        label={chat.receiverType || 'Support'}
                        size="small"
                        color={getChatColor(chat.receiverType)}
                        variant="outlined"
                        sx={{
                          fontSize: '0.55rem',
                          height: '18px',
                          flexShrink: 0,
                          '& .MuiChip-label': { px: 0.3 }
                        }}
                      />
                    </Box>
                  </CardActionArea>
                ))
              ) : (
                <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '100%',
                  p: 2
                }}>
                  <ChatIcon sx={{ fontSize: 48, color: 'text.secondary', mb: 1 }} />
                  <Typography variant="body1" gutterBottom sx={{ fontSize: '0.9rem' }}>
                    No Chats Found
                  </Typography>
                  <Typography variant="caption" color="text.secondary" sx={{ textAlign: 'center', fontSize: '0.75rem' }}>
                    {searchQuery ? 'No chats match your search' : 'No active customer chats'}
                  </Typography>
                </Box>
              )}
            </Box>
          </Card>
        </Grid>

        {/* Chat Messages */}
        <Grid item xs={12} md={9}>
          <Card sx={{
            height: '100%',
            borderRadius: 3,
            display: 'flex',
            flexDirection: 'column',
            background: `linear-gradient(135deg, ${theme.palette.background.paper}, ${alpha(theme.palette.secondary.main, 0.02)})`,
            border: `1px solid ${alpha(theme.palette.secondary.main, 0.1)}`,
            boxShadow: theme.shadows[3]
          }}>
            {selectedChat && selectedChat._id ? (
              <>
                {/* Chat Header */}
                <CardContent sx={{
                  p: 2,
                  pb: 1,
                  borderBottom: `1px solid ${alpha(theme.palette.divider, 0.2)}`,
                  background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)}, ${alpha(theme.palette.secondary.main, 0.05)})`,
                  borderRadius: '12px 12px 0 0'
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Avatar sx={{
                        bgcolor: getChatColor(selectedChat.receiverType) === 'primary' ?
                          theme.palette.primary.main : theme.palette.secondary.main,
                        width: 40,
                        height: 40
                      }}>
                        {getChatIcon(selectedChat.receiverType)}
                      </Avatar>
                      <Box>
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                          {selectedChat.sender || 'Unknown User'}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {selectedChat.receiverType || 'Support'} • {formatDate(selectedChat.createdAt)}
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <Chip
                        label={selectedChat.status || 'Active'}
                        size="small"
                        color={selectedChat.status === 'resolved' ? 'success' : 'warning'}
                      />
                      <IconButton
                        size="small"
                        onClick={() => {
                          // Silent refresh
                          loadMessages(selectedChat._id);
                          loadChats(); // Also refresh chat list
                        }}
                      >
                        <RefreshIcon />
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => {
                          // Test typing indicator
                          console.log('React: Testing typing indicator, current state:', isTyping);
                          setIsTyping(!isTyping);
                        }}
                        sx={{ color: 'orange' }}
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton size="small">
                        <MoreVertIcon />
                      </IconButton>
                    </Box>
                  </Box>
                </CardContent>

                {/* Messages Area */}
                <Box sx={{
                  flex: 1,
                  overflow: 'auto',
                  p: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1,
                  maxHeight: '400px',
                  '&::-webkit-scrollbar': {
                    width: '6px',
                  },
                  '&::-webkit-scrollbar-track': {
                    background: alpha(theme.palette.divider, 0.1),
                    borderRadius: '3px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: alpha(theme.palette.primary.main, 0.3),
                    borderRadius: '3px',
                    '&:hover': {
                      background: alpha(theme.palette.primary.main, 0.5),
                    },
                  },
                }}>
                  {messages.length > 0 ? (
                    messages.filter(message => message !== null).map((message) => {
                      // Add safety checks for message properties
                      if (!message || typeof message !== 'object') {
                        console.warn('Invalid message object:', message);
                        return null;
                      }

                      // Check if the message is from the current user (admin/agent)
                      // The current user could be the receiver in the chat
                      const isCurrentUser = message.sender === currentUser?.username ||
                        message.receiver === currentUser?.username;
                      const isFromCurrentUser = message.sender === currentUser?.username;

                      console.log('Message:', {
                        sender: message.sender,
                        receiver: message.receiver,
                        currentUser: currentUser?.username,
                        isFromCurrentUser
                      });

                      return (
                        <Box
                          key={message._id}
                          sx={{
                            display: 'flex',
                            justifyContent: isFromCurrentUser ? 'flex-end' : 'flex-start',
                            gap: 1,
                            animation: 'slideIn 0.3s ease-out',
                            '@keyframes slideIn': {
                              '0%': {
                                opacity: 0,
                                transform: isFromCurrentUser ? 'translateX(20px)' : 'translateX(-20px)'
                              },
                              '100%': {
                                opacity: 1,
                                transform: 'translateX(0)'
                              }
                            }
                          }}
                        >
                          {!isFromCurrentUser && (
                            <Avatar sx={{ width: 32, height: 32, fontSize: '0.75rem' }}>
                              {(message.sender || 'U').charAt(0).toUpperCase()}
                            </Avatar>
                          )}
                          <Box
                            sx={{
                              maxWidth: '70%',
                              minWidth: '100px',
                              p: 1.5,
                              borderRadius: isFromCurrentUser ? '16px 16px 4px 16px' : '16px 16px 16px 4px',
                              bgcolor: isFromCurrentUser ?
                                theme.palette.primary.main :
                                theme.palette.mode === 'dark' ?
                                  alpha(theme.palette.grey[800], 0.8) :
                                  alpha(theme.palette.grey[100], 0.8),
                              color: isFromCurrentUser ?
                                'white' : theme.palette.text.primary,
                              boxShadow: theme.shadows[1],
                              position: 'relative',
                              '&::before': {
                                content: '""',
                                position: 'absolute',
                                top: isFromCurrentUser ? '50%' : '50%',
                                [isFromCurrentUser ? 'right' : 'left']: '-6px',
                                transform: 'translateY(-50%)',
                                width: 0,
                                height: 0,
                                borderStyle: 'solid',
                                [isFromCurrentUser ? 'borderLeft' : 'borderRight']: '6px solid transparent',
                                [isFromCurrentUser ? 'borderRight' : 'borderLeft']: '6px solid transparent',
                                [isFromCurrentUser ? 'borderTop' : 'borderTop']: `6px solid ${isFromCurrentUser ?
                                  theme.palette.primary.main :
                                  theme.palette.mode === 'dark' ?
                                    alpha(theme.palette.grey[800], 0.8) :
                                    alpha(theme.palette.grey[100], 0.8)}`,
                              }
                            }}
                          >
                            {/* Display media if present */}
                            {message.mediaUrl && message.messageType === 'image' && (
                              <Box sx={{ mb: 1 }}>
                                <Box
                                  onClick={() => handleMediaPreview(message.mediaUrl, 'image')}
                                  sx={{
                                    cursor: 'pointer',
                                    position: 'relative',
                                    borderRadius: 1,
                                    overflow: 'hidden',
                                    '&:hover .media-overlay': {
                                      opacity: 1,
                                    },
                                  }}
                                >
                                  <img
                                    src={message.mediaUrl}
                                    alt="Chat media"
                                    style={{
                                      width: '100%',
                                      maxWidth: 200,
                                      maxHeight: 150,
                                      objectFit: 'cover',
                                      borderRadius: 4,
                                    }}
                                    onError={(e) => {
                                      e.target.style.display = 'none';
                                    }}
                                  />
                                  <Box
                                    className="media-overlay"
                                    sx={{
                                      position: 'absolute',
                                      top: 8,
                                      right: 8,
                                      background: 'rgba(0, 0, 0, 0.6)',
                                      borderRadius: 1,
                                      p: 0.5,
                                      opacity: 0,
                                      transition: 'opacity 0.2s',
                                    }}
                                  >
                                    <ZoomInIcon sx={{ color: 'white', fontSize: 16 }} />
                                  </Box>
                                </Box>
                              </Box>
                            )}

                            {/* Display file if present */}
                            {message.mediaUrl && message.messageType === 'file' && (
                              <Box sx={{ mb: 1 }}>
                                <Box
                                  onClick={() => handleMediaPreview(message.mediaUrl, 'file')}
                                  sx={{
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    p: 1,
                                    borderRadius: 1,
                                    bgcolor: alpha(theme.palette.primary.main, 0.1),
                                    border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
                                    '&:hover': {
                                      bgcolor: alpha(theme.palette.primary.main, 0.15),
                                    },
                                  }}
                                >
                                  <DownloadIcon sx={{ fontSize: 20 }} />
                                  <Typography variant="body2" sx={{ flex: 1 }}>
                                    {message.mediaFileName || 'File'}
                                  </Typography>
                                  <ZoomInIcon sx={{ fontSize: 16 }} />
                                </Box>
                              </Box>
                            )}

                            {/* Display text content */}
                            {message.content && (
                              <Typography
                                variant="body2"
                                sx={{
                                  mb: 0.5,
                                  wordBreak: 'break-word',
                                  lineHeight: 1.4,
                                  fontSize: '0.875rem'
                                }}
                              >
                                {message.content && message.content.length > 200
                                  ? `${message.content.substring(0, 200)}...`
                                  : (message.content || 'Message content unavailable')
                                }
                              </Typography>
                            )}

                            <Box sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 0.5,
                              justifyContent: isFromCurrentUser ? 'flex-end' : 'flex-start'
                            }}>
                              <Typography variant="caption" sx={{
                                opacity: 0.7,
                                fontSize: '0.7rem'
                              }}>
                                {formatTime(message.createdAt || message.timestamp)}
                              </Typography>
                              {isFromCurrentUser && (
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  {message.isRead ? (
                                    <CheckCircleIcon
                                      sx={{
                                        fontSize: 14,
                                        color: theme.palette.primary.main,
                                        ml: 0.5
                                      }}
                                    />
                                  ) : (
                                    <CheckCircleIcon
                                      sx={{
                                        fontSize: 14,
                                        color: 'text.secondary',
                                        ml: 0.5
                                      }}
                                    />
                                  )}
                                </Box>
                              )}
                            </Box>
                          </Box>
                          {isFromCurrentUser && (
                            <Avatar sx={{
                              width: 32,
                              height: 32,
                              fontSize: '0.75rem',
                              bgcolor: theme.palette.primary.main
                            }}>
                              {(currentUser?.username || 'A').charAt(0).toUpperCase()}
                            </Avatar>
                          )}
                        </Box>
                      );
                    })
                  ) : (
                    <Box sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: '100%',
                      p: 3
                    }}>
                      <ChatIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
                      <Typography variant="h6" gutterBottom>
                        No Messages Yet
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
                        Start the conversation by sending a message
                      </Typography>
                    </Box>
                  )}

                  {/* Typing Indicator Bubble */}
                  {isTyping && (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        gap: 1,
                        animation: 'slideIn 0.3s ease-out',
                        '@keyframes slideIn': {
                          '0%': {
                            opacity: 0,
                            transform: 'translateX(-20px)'
                          },
                          '100%': {
                            opacity: 1,
                            transform: 'translateX(0)'
                          }
                        }
                      }}
                    >
                      <Avatar sx={{ width: 32, height: 32, fontSize: '0.75rem' }}>
                        {(selectedChat?.sender || 'U').charAt(0).toUpperCase()}
                      </Avatar>
                      <Box
                        sx={{
                          maxWidth: '70%',
                          minWidth: '80px',
                          p: 1.5,
                          borderRadius: '16px 16px 16px 4px',
                          bgcolor: theme.palette.mode === 'dark' ?
                            alpha(theme.palette.grey[800], 0.8) :
                            alpha(theme.palette.grey[100], 0.8),
                          color: theme.palette.text.primary,
                          boxShadow: theme.shadows[1],
                          position: 'relative',
                          '&::before': {
                            content: '""',
                            position: 'absolute',
                            top: '50%',
                            left: '-6px',
                            transform: 'translateY(-50%)',
                            width: 0,
                            height: 0,
                            borderStyle: 'solid',
                            borderRight: '6px solid transparent',
                            borderLeft: '6px solid transparent',
                            borderTop: `6px solid ${theme.palette.mode === 'dark' ?
                              alpha(theme.palette.grey[800], 0.8) :
                              alpha(theme.palette.grey[100], 0.8)}`,
                          }
                        }}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <Box sx={{ display: 'flex', gap: 0.5 }}>
                            <Box
                              sx={{
                                width: 6,
                                height: 6,
                                borderRadius: '50%',
                                bgcolor: theme.palette.text.secondary,
                                animation: 'typingDot 1.4s infinite ease-in-out',
                                '&:nth-of-type(1)': {
                                  animationDelay: '0s',
                                },
                                '&:nth-of-type(2)': {
                                  animationDelay: '0.2s',
                                },
                                '&:nth-of-type(3)': {
                                  animationDelay: '0.4s',
                                },
                                '@keyframes typingDot': {
                                  '0%, 60%, 100%': {
                                    transform: 'translateY(0)',
                                    opacity: 0.4,
                                  },
                                  '30%': {
                                    transform: 'translateY(-8px)',
                                    opacity: 1,
                                  },
                                },
                              }}
                            />
                            <Box
                              sx={{
                                width: 6,
                                height: 6,
                                borderRadius: '50%',
                                bgcolor: theme.palette.text.secondary,
                                animation: 'typingDot 1.4s infinite ease-in-out',
                                '&:nth-of-type(1)': {
                                  animationDelay: '0s',
                                },
                                '&:nth-of-type(2)': {
                                  animationDelay: '0.2s',
                                },
                                '&:nth-of-type(3)': {
                                  animationDelay: '0.4s',
                                },
                                '@keyframes typingDot': {
                                  '0%, 60%, 100%': {
                                    transform: 'translateY(0)',
                                    opacity: 0.4,
                                  },
                                  '30%': {
                                    transform: 'translateY(-8px)',
                                    opacity: 1,
                                  },
                                },
                              }}
                            />
                            <Box
                              sx={{
                                width: 6,
                                height: 6,
                                borderRadius: '50%',
                                bgcolor: theme.palette.text.secondary,
                                animation: 'typingDot 1.4s infinite ease-in-out',
                                '&:nth-of-type(1)': {
                                  animationDelay: '0s',
                                },
                                '&:nth-of-type(2)': {
                                  animationDelay: '0.2s',
                                },
                                '&:nth-of-type(3)': {
                                  animationDelay: '0.4s',
                                },
                                '@keyframes typingDot': {
                                  '0%, 60%, 100%': {
                                    transform: 'translateY(0)',
                                    opacity: 0.4,
                                  },
                                  '30%': {
                                    transform: 'translateY(-8px)',
                                    opacity: 1,
                                  },
                                },
                              }}
                            />
                          </Box>
                          <Typography variant="caption" sx={{
                            color: theme.palette.text.secondary,
                            fontSize: '0.7rem',
                            ml: 0.5
                          }}>
                            typing...
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  )}

                  <div ref={messagesEndRef} />
                </Box>

                {/* Message Input */}
                <CardContent sx={{
                  p: 2,
                  pt: 1,
                  borderTop: `1px solid ${alpha(theme.palette.divider, 0.2)}`,
                  background: `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 0.8)}, ${alpha(theme.palette.primary.main, 0.02)})`,
                  borderRadius: '0 0 12px 12px'
                }}>
                  <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                    {/* Media attachment button */}
                    <input
                      accept="image/*"
                      style={{ display: 'none' }}
                      id="media-file-input"
                      type="file"
                      onChange={handleFileSelect}
                      disabled={uploadingMedia}
                    />
                    <label htmlFor="media-file-input">
                      <IconButton
                        component="span"
                        disabled={uploadingMedia}
                        sx={{
                          color: theme.palette.primary.main,
                          '&:hover': {
                            bgcolor: alpha(theme.palette.primary.main, 0.1),
                          },
                        }}
                      >
                        {uploadingMedia ? (
                          <CircularProgress size={20} />
                        ) : (
                          <UploadIcon />
                        )}
                      </IconButton>
                    </label>

                    <TextField
                      fullWidth
                      size="small"
                      placeholder="Type your message..."
                      value={messageText}
                      onChange={(e) => {
                        setMessageText(e.target.value);

                        // Handle typing indicators
                        if (selectedChat && socketService.isConnected) {
                          // Clear existing timer
                          if (typingTimer) {
                            clearTimeout(typingTimer);
                          }

                          // Start typing indicator
                          socketService.startTyping(selectedChat._id);

                          // Set timer to stop typing indicator
                          const timer = setTimeout(() => {
                            socketService.stopTyping(selectedChat._id);
                          }, 2000);

                          setTypingTimer(timer);
                        }
                      }}
                      onKeyPress={(e) => e.key === 'Enter' && sendMessage()}
                      disabled={sending || uploadingMedia}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          background: theme.palette.background.paper,
                          '&:hover': {
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor: theme.palette.primary.main,
                            }
                          },
                          '&.Mui-focused': {
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor: theme.palette.primary.main,
                              borderWidth: 2
                            }
                          }
                        }
                      }}
                      InputProps={{
                        endAdornment: (
                          <IconButton
                            onClick={sendMessage}
                            disabled={!messageText.trim() || sending || uploadingMedia}
                            color="primary"
                            sx={{
                              background: messageText.trim() && !sending && !uploadingMedia ?
                                `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})` :
                                'transparent',
                              color: messageText.trim() && !sending && !uploadingMedia ? 'white' : theme.palette.primary.main,
                              '&:hover': {
                                background: messageText.trim() && !sending && !uploadingMedia ?
                                  `linear-gradient(135deg, ${theme.palette.primary.dark}, ${theme.palette.secondary.dark})` :
                                  alpha(theme.palette.primary.main, 0.1)
                              }
                            }}
                          >
                            {sending || uploadingMedia ? (
                              <CircularProgress size={20} />
                            ) : (
                              <SendIcon />
                            )}
                          </IconButton>
                        )
                      }}
                    />
                  </Box>
                </CardContent>
              </>
            ) : (
              <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                p: 3
              }}>
                <ChatIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
                <Typography variant="h6" gutterBottom>
                  Select a Chat
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
                  Choose a conversation from the list to start messaging
                </Typography>
              </Box>
            )}
          </Card>
        </Grid>
      </Grid>

      {/* Media Preview Modal */}
      <Dialog
        open={mediaPreview.open}
        onClose={closeMediaPreview}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            background: theme.palette.mode === 'dark' ? '#1a1a1a' : '#fff',
            boxShadow: theme.shadows[24],
          }
        }}
      >
        <DialogTitle sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: 1
        }}>
          <Typography variant="h6">
            {mediaPreview.type === 'image' ? 'Image Preview' : 'File Preview'}
          </Typography>
          <IconButton onClick={closeMediaPreview}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 0, textAlign: 'center' }}>
          {mediaPreview.type === 'image' ? (
            <Box
              sx={{
                width: '100%',
                height: '60vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: theme.palette.mode === 'dark' ? '#000' : '#f5f5f5',
              }}
            >
              <img
                src={mediaPreview.url}
                alt="Preview"
                style={{
                  maxWidth: '100%',
                  maxHeight: '100%',
                  objectFit: 'contain',
                }}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <Box
                sx={{
                  display: 'none',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '100%',
                  color: theme.palette.text.secondary,
                }}
              >
                <ImageNotSupportedIcon sx={{ fontSize: 64, mb: 2 }} />
                <Typography variant="h6">Failed to load image</Typography>
              </Box>
            </Box>
          ) : (
            <Box sx={{ p: 3, textAlign: 'center' }}>
              <DownloadIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
              <Typography variant="h6" gutterBottom>
                File Preview
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                {mediaPreview.url.split('/').pop()}
              </Typography>
              <Button
                variant="contained"
                startIcon={<DownloadIcon />}
                onClick={() => {
                  const link = document.createElement('a');
                  link.href = mediaPreview.url;
                  link.download = mediaPreview.url.split('/').pop();
                  link.click();
                }}
                sx={{
                  background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                }}
              >
                Download File
              </Button>
            </Box>
          )}
        </DialogContent>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{
            width: '100%',
            borderRadius: 2,
            boxShadow: theme.shadows[8]
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ChatPage;